exports = module.exports = require("./../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mobile-padded{margin-bottom:20px}", "", {"version":3,"sources":["/../../sass-loader/index.js?sourceMap!/buddy/fm-connect-xamarin/client/app/components/apps/client/app/components/apps/newsItem/newsItem.scss"],"names":[],"mappings":"AAAA,eACE,kBAAmB,CAEpB","file":"newsItem.scss","sourcesContent":[".mobile-padded {\n  margin-bottom: 20px;\n\n}"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/sass-loader?sourceMap!./client/app/components/apps/newsItem/newsItem.scss
// module id = 586
// module chunks = 0